import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';

@Component({
  templateUrl: 'additional-income-header.component.html',
  styleUrls: ['additional-income-header.component.scss'],
  imports: [NgClass],
})
export class AdditionalIncomeHeaderFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  public get numColumns(): number {
    return this.props.numColumns ?? 3;
  }
}
